<template>
	
	
	<div class="relative w" id="bannerSwiper" >
		<div class="swiper-container ">
      <div class="swiper-wrapper">
        <div class="swiper-slide relative">
        	<img src="" :data-lazy='require("../images/index-banner.png")' class="f-left img"/>
        	<div class="swiper-text">
        		<div>用临床的标准</div>
        		<div>做孕期零食的专业品牌</div>
        		<div class="swiper-text-line bg-255 mg-tb-25"></div>
        		<div class="font-30 phone-swiper-text">Designed for</div>
        		<div class="font-30 phone-swiper-text">Mohthers</div>
        	</div>
        </div>
        <div class="swiper-slide relative">
        	<img src="" :data-lazy='require("../images/index-banner1.png")' class="f-left img"/>
        	<div class="swiper-text">
        		<div class="font-30 phone-swiper-text">Designed for</div>
        		<div class="font-30 phone-swiper-text">Mohthers</div>
        		<div>a1<sup>+</sup>孕期零食科学家</div>
        		<div>重科研、求实效</div>
        		<div class="swiper-text-line bg-255 mg-tb-25"></div>
        	</div>
        </div>
      </div>
      <div class="swiper-button-prev" ></div>
　　		<div class="swiper-button-next" ></div>
	  </div>
	</div>
</template>

<script>
	import Swiper from '../../../js/swiper/js/swiper.min.js'
	export default {
	  name: 'App',
	   data() {
	      return {
	        windowWidth:this.$utils.windowWidth
	      }
	   },
	    mounted() {
			var swiper = new Swiper('#bannerSwiper .swiper-container', {
				loop:true,
				observer: true, 
				autoplay:5000,
				pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
				    nextEl: '#bannerSwiper .swiper-button-next',
				    prevEl: '#bannerSwiper .swiper-button-prev',
				},
		    });
	    }
	}
</script>

<style scoped="scoped">
	#bannerSwiper{}
	#bannerSwiper .swiper-container {width: 100%;}
	#bannerSwiper .img{width: 100%;}
	#bannerSwiper .swiper-button-prev{background: url(../images/swipericon.png) no-repeat;width: 80px;height: 150px;left: 80px;color: rgb(200,200,200);outline: none;margin-top: -70px;
	transform: rotate(-180deg);}
	#bannerSwiper .swiper-button-next{background: url(../images/swipericon.png) no-repeat;width: 80px;height: 150px;right: 80px;color: rgb(200,200,200);outline: none;margin-top: -70px}
	#bannerSwiper .swiper-button-prev:after{content: '';}
	#bannerSwiper .swiper-button-next:after{content: '';}
	#bannerSwiper .swiper-text{font-size: 50px;position: absolute;left: 16%;top: 28%;
	text-shadow: 2px 2px 2px rgba(0,0,0,0.2);color: white;
	}
		#bannerSwiper .swiper-text-line{width: 60px;height: 4px;
		box-shadow: 2px 2px 2px rgba(0,0,0,0.2);}
		
		
	@media screen and (max-width: 1500px){
		#bannerSwiper .swiper-text{zoom: 0.75;}
		#bannerSwiper .swiper-button-prev{zoom: 0.55;}
		#bannerSwiper .swiper-button-next{zoom: 0.55;}
	}
	@media screen and (max-width: 1300px){
		#bannerSwiper .swiper-text{zoom: 0.65;}
	}
	@media screen and (max-width: 800px) {
		#bannerSwiper .swiper-container{padding-top: 50px;}
		#bannerSwiper .swiper-button-prev{zoom: 0.25;}
		#bannerSwiper .swiper-button-next{zoom: 0.25;}
		#bannerSwiper .swiper-text{zoom: 0.7;font-size: 24px;top: 50px;left: 13%;}
		#bannerSwiper .swiper-text-line{margin-top: 10px;margin-bottom: 10px;}
		.phone-swiper-text{font-size: 16px;}
	}
</style>


